import { createFeatureSelector, createSelector } from '@ngrx/store';

const getPortalState = createFeatureSelector('PORTAL_STORE');

export const getStudentGroupingsSlice = createSelector(
  getPortalState,
  (state: any) => state.studentGroupings,
);

export const getStudentGroupingsLoadedStatus = createSelector(
  getStudentGroupingsSlice,
  (state: any) => state.loaded,
);

export const getStudentGroupingsData = createSelector(
  getStudentGroupingsSlice,
  (state: any) => state.studentGroupingsData,
);
